<div class="not-found-container">
  <h1>404</h1>
  <p>This page doesn't exist.</p>
  <a href="#" class="home-link" (click)="navigateToHome()">Go back home</a>
</div>
